var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-404"},[_c('div',{staticClass:"center-content"},[_c('img',{attrs:{"src":require("../assets/404.png"),"alt":""}}),_c('div',[_vm._v("您访问的页面不存在")])])])
}]

export { render, staticRenderFns }